import React, { useEffect, useState } from 'react';
import { MenuItem, FormControl } from '@mui/material';
import SmallSelect from "../styled/small-select.component";
import useCommonOvcodeUnilab from "../../hooks/useCommonOvcodeUnilab";

// TOOD: make region dropdown dynamic
export default function RegionSelect({onRegionChange, onCountryChange}) {

    const [region, setRegion] = useState(null);
    const [country, setCountry] = useState(null);
    const { loading, error, distinct_country, getDistinctCountry, distinct_region, getDistinctRegion } = useCommonOvcodeUnilab();

    useEffect(()=>{
        getDistinctCountry();
    }, [])

    useEffect(()=>{
        if(distinct_country == null) return;
        getDistinctRegion(distinct_country[0]?.country);
        setCountry(distinct_country[0]?.country); // TODO: eventually this needs a dropdown for countries
    }, [distinct_country])

    useEffect(()=>{
        if(distinct_region == null) return;
        setRegion(distinct_region[0].region)
    }, [distinct_region])

    useEffect(() => {
        if(onRegionChange){
            onRegionChange(region);
        }
    }, [region]);

    useEffect(() => {
        if(onCountryChange){
            onCountryChange(country);
        }
    }, [country]);
  
    const handleChange = (event) => {
        setRegion(event.target.value);
    };

    if(region == null) return <>Loading...</>;

    return (
        <div>
            <FormControl sx={{ minWidth: 80, width: '100%'}}>
                <SmallSelect
                    value={region}
                    onChange={handleChange}
                    displayEmpty
                    autoWidth
                    fontColor={'#5d5ed8'}
                >
                    {distinct_region?.map((region)=>{
                        return(
                            <MenuItem value={region.region}>{region.region}</MenuItem>
                        )
                    })}
                </SmallSelect>
            </FormControl>
        </div>
    );
}